import React, { useEffect, useState } from "react";
import Chart from "react-apexcharts";
import { DashboardAcompProducaoTableSemanal } from "../../../components/classes/DashAcompProducao";

export default function ChartProd02(props: ChartProd04Props){
  const [seriesMixedChart, setSeriesMixedChart] = useState<number[]>([]);
  const [optionsMixedChart, setOptionsMixedChart] = useState<ApexCharts.ApexOptions>({
    dataLabels: {
      enabled: true,
      style:{
        fontSize: "15",
        fontFamily: "Roboto",
        colors: ['white']
      },
      background: {
        enabled: true,
        foreColor: 'black',
        padding: 4,
        borderRadius: 1,
        borderWidth: 1,
        borderColor: 'black',
        opacity: 0.9,
        dropShadow: {
          enabled: true,
          top: 5,
          left: 5,
          blur: 1,
          color: '#000',
          opacity: 0.45
        }
      },
    }
  });

  useEffect(()=>{

    setSeriesMixedChart(
      props?.data?.justificativas.map(item=>{
          return item.porcentagem
      }) ?? []
    );

    setOptionsMixedChart(
      {
        ...optionsMixedChart,
        labels: props?.data?.justificativas.map(item=>{
          return item.justificativa
      }) ?? []
      }
    );

  }, [props])

  return (
    <div id="chart" style={{maxWidth: 500}}>
      <Chart options={optionsMixedChart} series={seriesMixedChart} type="pie" />
    </div>
  );
}

interface ChartProd04Props{
  data?: DashboardAcompProducaoTableSemanal
}